module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "US_INC_banner.e526da18.jpg";